import { Component, OnInit} from '@angular/core';
import { Router } from "@angular/router";
import { LoginService } from 'src/app/services/login.service';
 
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
}) 


export class HomeComponent implements OnInit{
 
verFacturas : boolean =false;
verOrdenes : boolean = false;
nombre: any = '';
razon: any = '';
toggle: boolean = false;
mostrarModal: boolean = false;
  // Modal configuration
  modalConfig = {
    show: false,
    type: 'success' as 'success' | 'error' | 'warning' | 'info',
    title: '',
    message: '',
    confirmText: 'Aceptar',
    showCancel: false,
    onConfirm: () => { },
    onCancel: undefined as (() => void) | undefined
  };

HABILITAR_PANTALLA_OC_PENDIENTE: boolean = false;
HABILITAR_BOTON_SUBIR_PDF: boolean = false;
HABILITAR_MENU_COMPROBANTES_PROVEEDORES: boolean = false;

constructor(private router: Router,
            loginService: LoginService) {
 this.HABILITAR_PANTALLA_OC_PENDIENTE = sessionStorage.getItem('HPOCP') === 'S' ? true : false;
 this.HABILITAR_BOTON_SUBIR_PDF = sessionStorage.getItem('HBSPDF') === 'S' ? true : false;
 this.HABILITAR_MENU_COMPROBANTES_PROVEEDORES = sessionStorage.getItem('HMCP') === 'S' ? true : false;
};


ngOnInit(): void {
  this.nombre = localStorage.getItem('nombre');
  this.razon = localStorage.getItem('razon');
  

  if((localStorage.getItem('nro_cliente')===''||localStorage.getItem('nro_cliente')===null)&&(localStorage.getItem('nro_proveedor')===''||localStorage.getItem('nro_proveedor')===null)){
    this.router.navigate(['login']);
  }

  if(localStorage.getItem('nro_cliente')!=''){
    this.verFacturas=true;
  }

  if(localStorage.getItem('nro_proveedor')!=''){
    this.verOrdenes=true;
  }

}

onMostrarAlerta(config: {
  type: 'success' | 'error' | 'warning' | 'info',
  title: string,
  message: string,
  confirmText?: string,
  showCancel?: boolean,
  onConfirm?: () => void,
  onCancel?: () => void
}) {
  // Mostrar la alerta de manera simple sin callbacks complejos
  this.showModal({
    type: config.type,
    title: config.title,
    message: config.message,
    confirmText: config.confirmText || 'Aceptar',
    showCancel: config.showCancel || false,
    onConfirm: () => {
      this.hideModal();
    },
    onCancel: () => {
      this.hideModal();
    }
  });
}

onAlertModalClose() {
  if (this.modalConfig.onCancel) {
    this.modalConfig.onCancel();
  }
  this.hideModal();
}

onFacturasSubidas() {
  console.log('Facturas subidas');
}

abrirModalSubir() {
  this.mostrarModal = true;
}


cerrarModal() {
  this.mostrarModal = false;
}

showModal(config: {
  type: 'success' | 'error' | 'warning' | 'info',
  title: string,
  message: string,
  confirmText?: string,
  showCancel?: boolean,
  onConfirm: () => void,
  onCancel?: () => void
}) {
  this.modalConfig = {
    show: true,
    type: config.type,
    title: config.title,
    message: config.message,
    confirmText: config.confirmText || 'Aceptar',
    showCancel: config.showCancel || false,
    onConfirm: config.onConfirm,
    onCancel: config.onCancel
  };
}

hideModal() {
  this.modalConfig.show = false;
}


logout(){
  localStorage.removeItem('cuenta');
  localStorage.removeItem('usuario');
  localStorage.removeItem('nombre');
  localStorage.removeItem('nro_cliente');
  localStorage.removeItem('nro_proveedor');
  localStorage.removeItem('razon');
  sessionStorage.clear();
}

escMenu(){
 this.toggle?this.toggle=false:this.toggle=true;
}

}
